import { UseFormReturn } from 'react-hook-form'
import { Form } from './ui/Form'
import { FormValues } from './ui/Form/model'

type PassportStepProps = {
  onSuccess: (formValues: FormValues) => void
  form: UseFormReturn<FormValues>
}

export function PassportStep({ onSuccess, form }: PassportStepProps) {
  return <Form onSuccess={onSuccess} form={form} />
}
